import React,{ useState, useEffect,useRef  } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import DownloadIcon from "../../../styles/images/download-icon.png";

const ExportToExcelWithApi = (props) => {

    const [isDownloading, setIsDownloading] = useState(false);
    const isMountedRef = useRef(true); 
    const timeoutRef = useRef(null); 

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current); 
            }
        };
    }, []);

    useEffect(() => {
        if (props.data && props.data.length > 0 && isDownloading) {
            // Convert JSON to worksheet
          const worksheet = XLSX.utils.json_to_sheet(props.data);

          // Create a new workbook
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

          // Generate Excel file and trigger download
          const excelBuffer = XLSX.write(workbook, {
               bookType: "xlsx",
               type: "array",
          });
          const blob = new Blob([excelBuffer], {
               type: "application/octet-stream",
          });
          saveAs(blob, props.name + ".xlsx");

          setIsDownloading(false); 
        }
    }, [props.data]);

     const handleExport = () => {
        if (!isDownloading) {
            setIsDownloading(true);

            timeoutRef.current = setTimeout(() => {
               if (isMountedRef.current) {
                   setIsDownloading(false);
               }
           }, 8000);

            props.onDownloadClick((success) => {
               //clearTimeout(resetTimeout);
               if (!success) {
                   clearTimeout(timeoutRef.current);
                   setIsDownloading(false);
               }
           }); 
        }
     };

     return (
          <span className="sba-admin-download-icon" onClick={handleExport}>
               <img src={DownloadIcon}  />
          </span>
          
     );
};

export default ExportToExcelWithApi;
